import gql from "graphql-tag";

export default gql`
  mutation createPlaidLinkToken($companyId: ID!) {
    createPlaidLinkToken(companyId: $companyId) {
      linkToken
    }
  }
`;
